export interface VehicleFuel {
    id: number;
    name: string;
}

export const VEHICLE_FUELS: VehicleFuel[] = [
    { id: 0, name: "Empty" },
    { id: 1, name: "Diesel" },
    { id: 2, name: "Petrol" },
    { id: 3, name: "Gas" },
    { id: 4, name: "Electric" },
    { id: 5, name: "Hydrogen" }
];